module.exports = __webpack_public_path__ + "images/frieslandf7f7c4055cd150aba1fcf25d2e03395f.png";